import { PLATFORMS, STATUS_PILL, thumb } from "../data/mock.js";

export default function EventsTable({ events, selectedId, onSelect }) {
  return (
    <div className="listwrap">
      <table className="events">
        <thead>
          <tr>
            <th style={{width:"38%"}}>Event ↓</th>
            <th>Date</th>
            <th>Status</th>
            <th>Platforms</th>
            <th className="num">Sold / Cap</th>
            <th className="num">Gross</th>
          </tr>
        </thead>
        <tbody>
          {events.map((ev) => {
            const sold = Object.values(ev.sales).reduce((a,b)=>a+b,0);
            const gross = sold * ev.price;
            const pct = ev.cap ? Math.round(sold/ev.cap*100) : 0;
            const [h1, h2] = ev.hue.split(",");
            const sp = STATUS_PILL[ev.status];
            return (
              <tr key={ev.id}
                  className={selectedId===ev.id?"sel":""}
                  onClick={()=>onSelect(ev.id)}>
                <td>
                  <div className="cell-event">
                    <div className="thumb" style={{backgroundImage:`url('${thumb(ev.code,h1,h2)}')`}}/>
                    <div className="meta">
                      <div className="ttl">{ev.title}</div>
                      <div className="sub">{ev.sub} · {ev.venue}, {ev.city}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div className="date-block">
                    <span className="d">{ev.date}</span>
                    <span className="t">{ev.time}</span>
                  </div>
                </td>
                <td><span className={`pill ${sp.cls}`}>{sp.label}</span></td>
                <td>
                  <div className="platforms">
                    {Object.entries(ev.sales).map(([k,v]) => (
                      <span key={k}
                            className={`pdot${v===0?" dim":""}`}
                            style={{background:PLATFORMS[k].color}}
                            data-tip={`${PLATFORMS[k].name} · ${v} sold`}>
                        {PLATFORMS[k].code}
                      </span>
                    ))}
                  </div>
                </td>
                <td className="num">
                  <div className="stackbar">
                    {Object.entries(ev.sales).filter(([,v])=>v>0).map(([k,v]) => (
                      <span key={k} style={{width:`${v/ev.cap*100}%`,background:PLATFORMS[k].color}}/>
                    ))}
                  </div>
                  <div className="stack-meta" style={{justifyContent:"flex-end"}}>
                    <b>{sold.toLocaleString()}</b>
                    <span style={{color:"var(--ink-4)"}}>/</span>
                    <span>{ev.cap.toLocaleString()}</span>
                    <span className={`pct${pct>=70?" hot":""}`}>{pct}%</span>
                  </div>
                </td>
                <td className="num revenue">
                  <span className="cur">£</span>{gross.toLocaleString(undefined,{maximumFractionDigits:0})}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
